import { FilterChip } from "../../patterns/FilterChip";

interface CustomerScopeChipProps {
  customerName: string | null;
  onDismiss: () => void;
}

export function CustomerScopeChip({
  customerName,
  onDismiss,
}: CustomerScopeChipProps) {
  return (
    <FilterChip
      label={`Customer: ${customerName ?? "…"}`}
      onDismiss={onDismiss}
      dismissLabel="Remove customer filter"
    />
  );
}
